export default {
    /**
     * Datos añadidos a data por el mixin:
     * - addressTypesOptions: array con tipos de direcciones
     *
     * @return {Object} Data del mixin
     */
    data() {
        return {
            addressTypesOptions: []
        };
    },
    methods: {
        /**
         * Load Address types
         */
        loadAddressTypesOptions() {
            const addressTypes = this.$t(`interveners.crs.address_type`);
            this.addressTypesOptions = Object.entries(addressTypes).map(item => {
                return {
                    key: item[0],
                    name: item[1]
                };
            });
        }
    },

    /**
     * Antes de montar el componente se cargan los tipos de direcciones en la variable
     * `this.AddressTypesOptions`
     */
    beforeMount() {
        this.loadAddressTypesOptions();
    }
};
